import { Divider, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { IComplianceChecklistAnswers } from "interfaces/grant-vestment-request";

interface ComplianceChecklistViewModalProps {
  visible: boolean;
  close: () => void;
  complianceChecklist: IComplianceChecklistAnswers | undefined;
}

export const ComplianceChecklistViewModal: React.FC<
  ComplianceChecklistViewModalProps
> = ({ visible, close, complianceChecklist }) => {
  const yesNo = (value: boolean) => (value ? "YES" : "NO");

  return (
    <Dialog open={visible} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle color="primary">Compliance Checklist</DialogTitle>
      <Divider />
      <DialogContent>
        {!complianceChecklist ? (
          <Typography color="text.secondary">
            No compliance checklist data for this request.
          </Typography>
        ) : (
          <>
            <TextField
              value={yesNo(complianceChecklist.hasOwnershipInterests)}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Has Ownership Interests"
              disabled
            />
            {complianceChecklist.hasOwnershipInterests && (
              <TextField
                value={
                  complianceChecklist.ownershipInterestsExplanation ?? ""
                }
                margin="normal"
                fullWidth
                multiline
                minRows={2}
                InputLabelProps={{ shrink: true }}
                label="Ownership Interests Explanation"
                disabled
              />
            )}

            <TextField
              value={yesNo(complianceChecklist.hasVotingRights)}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Has Voting Rights"
              disabled
            />
            {complianceChecklist.hasVotingRights && (
              <TextField
                value={complianceChecklist.votingRightsExplanation ?? ""}
                margin="normal"
                fullWidth
                multiline
                minRows={2}
                InputLabelProps={{ shrink: true }}
                label="Voting Rights Explanation"
                disabled
              />
            )}

            <TextField
              value={yesNo(complianceChecklist.hasOtherRelationship)}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Has Other Relationship"
              disabled
            />
            {complianceChecklist.hasOtherRelationship && (
              <TextField
                value={
                  complianceChecklist.otherRelationshipExplanation ?? ""
                }
                margin="normal"
                fullWidth
                multiline
                minRows={2}
                InputLabelProps={{ shrink: true }}
                label="Other Relationship Explanation"
                disabled
              />
            )}

            <TextField
              value={yesNo(
                complianceChecklist.hasArrangementsRelatedToTransaction
              )}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Has Arrangements Related to Transaction"
              disabled
            />
            {complianceChecklist.hasArrangementsRelatedToTransaction && (
              <TextField
                value={
                  complianceChecklist.arrangementsRelatedToTransactionExplanation ??
                  ""
                }
                margin="normal"
                fullWidth
                multiline
                minRows={2}
                InputLabelProps={{ shrink: true }}
                label="Arrangements Related to Transaction Explanation"
                disabled
              />
            )}
          </>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="contained" color="primary" onClick={close}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
